package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.pathParamFollowing
import com.fsryan.foundation.net.client.replacePathParams

class WMFileEventStreamRequestBuilder: FSAuthenticatedRequestBuilder<WMFileEventStreamRequestBuilder, Nothing>() {

    var eventStreamId: String? = null

    fun eventStreamId(eventStreamId: String) = apply {
        this.eventStreamId = eventStreamId
    }

    override fun applyFrom(request: FSRequest<Nothing>): WMFileEventStreamRequestBuilder {
        eventStreamId = request.pathParamFollowing("events")
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Get)
        eventStreamId?.let { replacePathParams("api", "v1", "events", it) }
        return super.build()
    }

    override fun self(): WMFileEventStreamRequestBuilder = this

    override fun clear(): WMFileEventStreamRequestBuilder {
        eventStreamId = null
        return super.clear()
    }
}